import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { toggleDialog } from 'actions/view'
import Button from 'components/theme/Button'
import ThirdPartyEndpointForm from './ThirdPartyEndpointForm'
import { create, update } from 'actions/data'

const AddOrEditEndpointDialog = ({
  fullScreen,
  dialogOpen,
  classes,
  toggleDialog,
  history,
  thenFunc,
  create,
  update,
  id,
  initialData,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      fullScreen={fullScreen}
      open={Boolean(dialogOpen)}
      onClose={() => {
        toggleDialog({
          open: false,
          dialog: 'AddOrEditEndpoint',
        })
      }}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{ classes: { rounded: classes.rounded } }}
    >
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        <ThirdPartyEndpointForm
          onSubmit={
            !id || id === 'new'
              ? data =>
                  create({
                    entityType: 'endpoint',
                    entity: data,
                  }).then(payload => {
                    if (thenFunc) {
                      thenFunc(payload)
                    }
                  })
              : data =>
                  update({ ...data, id }, 'endpoint').then(payload => {
                    if (thenFunc) {
                      thenFunc(payload)
                    }
                  })
          }
          initialData={initialData}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            toggleDialog({ open: false, dialog: 'AddOrEditEndpoint' })
          }}
          color="primary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withRouter(
  connect(
    state => ({
      dialogOpen: state.view.dialogs?.AddOrEditEndpoint?.open,
    }),
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
          create,
          update,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {
          borderRadius: 28,
          overflowY: 'hidden',
          // height: '100%',
          [theme.breakpoints.down('sm')]: {
            borderRadius: 0,
            overflowY: 'auto',
          },
        },
        dialogContentRoot: {
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
      }))(AddOrEditEndpointDialog),
    ),
  ),
)
